import { Box } from '@chakra-ui/react';
import { FlexRow } from 'components/layout/FlexRow';
import { Map } from 'pages/ProjectInsights/Map';
import SearchResults from 'pages/ProjectInsights/ProjectLists/SearchResults';

const TOP_LIST_ID = 'top-list';

const containerStyle = {
  height: '100%',
  width: '100%',
};

const bodyStyle = {
  height: '100%',
  alignItems: 'normal',
  flexWrap: 'wrap',
  flex: 1,
  overflow: 'hidden',
  // Let flex grow/shrink size this column; minWidth:0 lets it shrink below its
  // content so it never pushes the map/list past the viewport.
  minWidth: 0,
};

const projectListStyle = {
  width: '400px',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  overflowY: 'auto',
};

const ProjectListComponent = () => {
  return (
    <FlexRow sx={containerStyle}>
      <Box sx={bodyStyle}>
        <Map />
      </Box>
      <Box sx={projectListStyle} id={TOP_LIST_ID}>
        <SearchResults />
      </Box>
    </FlexRow>
  );
};

export default ProjectListComponent;
